import type { ComponentType } from "react";
import type { LazyRouteFunction, RouteObject } from "react-router-dom";

const chunkReloadStorageKey = "energovizor:chunk-reload-at";

function isChunkLoadError(error: unknown) {
  if (!(error instanceof Error)) return false;

  return [
    "Failed to fetch dynamically imported module",
    "Importing a module script failed",
    "Loading chunk",
    "ChunkLoadError",
  ].some((message) => error.message.includes(message));
}

export function importComponent(importFnc: () => Promise<{ default: ComponentType }>): LazyRouteFunction<RouteObject> {
  return async () => {
    try {
      const Component = await importFnc();
      return { Component: Component.default };
    } catch (error) {
      if (!import.meta.env.DEV && isChunkLoadError(error)) {
        const lastReloadAt = Number(sessionStorage.getItem(chunkReloadStorageKey) ?? 0);

        if (Date.now() - lastReloadAt > 60_000) {
          sessionStorage.setItem(chunkReloadStorageKey, String(Date.now()));
          window.location.reload();
          await new Promise(() => undefined);
        }
      }

      throw error;
    }
  };
}
